// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606020903/js/" + chunkId + "." + {"44":"ff39b559","225":"c77d617f","481":"c5f41c6b","486":"f15f3bb4","770":"8706d524"}[chunkId] + ".0.3558614868143075.chunk.js";
};